import { useQuery } from '@tanstack/react-query'
import { Company } from 'models'
import { currentQueryService } from 'utils/api/queries'

const useGetCompanyById = (companyId?: string, options?: { enabled?: boolean }) =>
  useQuery<Company | null, Error>({
    queryKey: ['useGetCompanyById', companyId],
    queryFn: async () => {
      if (!companyId) {
        return null
      }
      return currentQueryService.getCompanyById(companyId)
    },
    enabled: Boolean(companyId) && (options?.enabled ?? true),
    staleTime: 1000 * 60 * 5,
  })

export { useGetCompanyById }
